<template>
  <std-form-page
      ref="page"
      :id="name"
      :item="item"
      identity="name"

      url="/inventory"
      resource="resource"

      icon="bi-tools"
      title-new="Добавить ресурс"
      :title="'Ресурс ' + name"

      :before-send="beforeSend"

  >
    <f-input v-model="item.name" label="Имя ресурса" w="3" :disabled="!!name"/>
    <f-input type="select" v-model="item.kind" label="Вид ресурса" w="3" :disabled="!!name">
      <option value="nlu">NLU</option>
      <option value="tgbot">Телеграм бот</option>
      <option value="maxbot">Макс бот</option>
      <option value="http_ep_config">Конфигурация HTTP ендпоинта</option>
    </f-input>
    <f-input v-model="item.description" label="Описание" w="6"/>

    <!--NLU-->
    <f-input v-if="item.kind=='nlu'" type="select" v-model="item.nlu_kind" label="Вид NLU" w="3">
      <option value="interpreter">Интерпретатор</option>
      <option value="generic">Программа-бот</option>
    </f-input>
    <f-input v-if="item.kind=='nlu'" v-model="item.nlu_url" label="NLU URL" w="9"/>

    <!--TGBOT-->
    <f-input v-if="item.kind=='tgbot'" v-model="item.bot_username" label="Username бота (без @)" w="12"/>
    <f-input v-if="item.kind=='tgbot'" v-model="item.bot_token" type="password" label="Токен бота" w="12"/>

    <!--MAXBOT-->
    <f-input v-if="item.kind=='maxbot'" v-model="item.bot_username" label="Username бота (без @)" w="12"/>
    <f-input v-if="item.kind=='maxbot'" v-model="item.bot_token" type="password" label="Токен бота" w="12"/>

    <!--ENDPOINT CONFIG-->
    <f-input type="textarea" v-if="item.kind=='http_ep_config'" v-model="item.http_ep_config_json" label="JSON конфигурация HTTP ендпоинта" rows="12" w="12"/>
    <f-input type="password" v-if="item.kind=='http_ep_config'" v-model="item.http_ep_config_secret" label="Секрет"/>

    <template v-slot:actions="form">
      <button
          v-if="!form.edit && (item.kind=='tgbot' || item.kind=='maxbot')"
          type="button"
          class="btn"
          :class="item.provisioned?'btn-danger':'btn-success'"
          @click="onProvision"
      >
        {{ item.provisioned ? "Отключить" : "Подключить" }}
      </button>
    </template>
  </std-form-page>

</template>

<script>
import FInput from "@/components/FInput";
import StdFormPage from "@/components/StdFormPage";
import {http} from "@/misc/http";

export default {
  components: {StdFormPage, FInput},
  props: ["name"],
  data() {
    return {
      item: {
        name: "",
        kind: "nlu",
        nlu_kind: "interpreter",
        http_ep_config_json: '{\n' +
            '    "dialog_id_path": "",\n' +
            '    "user_id_path": "",\n' +
            '    "user_input_path": "",\n' +
            '    "user_output_field": "",\n' +
            '    "message_id_field": "",\n' +
            '    "max_token_lifetime": 0\n' +
            '}\n',
      },
    }
  },

  methods: {
    onProvision() {
      if (this.item.provisioned && !confirm("Это отключит ресурс от обслуживания трафика, вы уверены?"))
        return;
      this.$refs.page.$refs.loader.wrap(
          async () => {
            this.item = await http.patch("/inventory/" + this.item.name + "/provision");
            return this.item.provisioned ? "Ресурс подключен" : "Ресурс отключен";
          }
      );
    },

    beforeSend() {
      if (this.item.kind == "http_ep_config")
        JSON.parse(this.item.http_ep_config_json);
      return true;
    },
  },

}
</script>

